import API from 'utils/api';
import { store } from 'store';

// eslint-disable-next-line func-names
export default async function (uri, type, config) {
  try {
    const res = await API.get(uri, config);
    if (res?.status === 200) {
      const payload = res.data || [];
      store.dispatch({
        type,
        payload,
      });
    }
  } catch (err) {
    // onError(err);
  }
}
